import { useContext } from "solid-js";
import { AppContext } from "../../app-context-provider/app-context-provider";
import { Screen } from "../../components/layout/screen/screen";
import { Categories } from "../../components/strategies/categories";
import { getCropTypeCategoriesQuery } from "../../graphql/queries/crops";

export const CategoriesContainer = () => {
    const { createCachedResource } = useContext(AppContext);
    const [cropTypeCategoriesData] = createCachedResource(getCropTypeCategoriesQuery);

    return (
        <Screen>
            <Categories cropTypeCategoriesData={cropTypeCategoriesData} />
        </Screen>
    );
};
